import { EvaluationStatus } from "@common/components/questionnaireComponents/evaluateQuestionnaireDialog/EvaluateQuestionnaireDialog.types";

// Mirrors Core/Filtering/FilterFieldType.cs by ordinal: the backend sends the enum as its int value.
export enum EntityFieldType {
    Text = 0,
    Number = 1,
    Date = 2,
    DateTime = 3,
    Boolean = 4,
    Decimal = 5,
    Status = 6,
    Guid = 7,
    BusinessAreaList = 8,
    EntityList = 9,
    TagList = 10,
    Template = 11,
    Amount = 12,
    Html = 13,
    MultiLineText = 14,
    CounterPartyWithSubContractors = 15,
    CurrencyCode = 16,
    Int = 17,
    RenewalCountdown = 18,
    AutoRenewal = 19,
    Countries = 20,
    SystemStatus = 21,
    SystemType = 22,
    SystemDataTypes = 23,
    SystemEntityType = 24,
    SystemStorageType = 25,
    SystemLevelOfCriticality = 26,
    RiskScore = 27,
    LevelOfProtection = 28,
    SystemIcon = 29,
    RiskAreas = 30,
    LegalEntityClassifications = 31,
    LegalEntityAuditStatus = 32,
    BooleanCheckmark = 33,
    LegalEntityStatus = 34,
    Contacts = 35,
    DateWithOptionalTime = 36,
    Evaluation = 37,
    IncidentLogStatus = 38,
    IncidentLogSeverity = 39,
    ProcessingActivityStatus = 40,
    Progress = 41,
    ProcessStatus = 42,
    ComplianceAreaList = 43,
    Timestamp = 44,
    ProcessingActivityProgress = 45,
}

export interface NameWithColor {
    name: string;
    color?: number;
}

export interface AmountWithCurrency {
    amount?: number;
    currencyCode: string;
}

// Mirrors Core/Filtering/DateWithOptionalTimeValue.cs: an ISO date and, only when one was given, an HH:mm:ss time. A
// date marked as having none carries the reason instead.
export interface DateWithOptionalTimeValue {
    date: string | null;
    time: string | null;
    noDateReason: NoDateReason | null;
}

export enum NoDateReason {
    Unknown = 1,
    Ongoing = 2,
}

export interface EvaluationValue {
    evaluationStatus: EvaluationStatus;
    evaluation: string | null;
}
